"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useCheckmarkStyles_unstable", {
    enumerable: true,
    get: function() {
        return _useCheckmarkStylesstyles.useCheckmarkStyles_unstable;
    }
});
const _useCheckmarkStylesstyles = require("./useCheckmarkStyles.styles");
